import { ExploreAllFilters } from "../../../explore/material/exploreAllFilters/ExploreAllFilters";
import React from "react";
import { BlogFiltersSlider } from "./BlogFiltersSlider";
import { BlogFiltersWrapper } from "./BlogFiltersWrapper";
import { BlogFiltersDivider } from "./BlogFiltersDivider";
import { BlogAllFiltersWrapper } from "./BlogAllFiltersWrapper";

export const BlogFilters = () => {
  return (
    <BlogFiltersWrapper>
      <BlogAllFiltersWrapper>
        <ExploreAllFilters
          filterFor={"blogs"}
          type={"objectives"}
          title="Filter By"
        />
        <BlogFiltersDivider />
      </BlogAllFiltersWrapper>

      <BlogFiltersSlider />
    </BlogFiltersWrapper>
  );
};
